<div *ngIf='!IsShowDetail'>
  <div class="row card-deck">
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form">
      <!--<div class="modal-header">
    <h4 class="modal-title">Contact &amp; Emergency Details</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>-->
      <h5 class="card-title">
        Contact &amp; Emergency Details
        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h5>
      <div class="modal-body">
        <!-- Form actions layout section start -->
      
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">


          <div class="form-body">
            <div class="row">
              <div class="form-group col-12 mb-2">
                <label for="eventInput2">Current Address</label>
                <input type="text" class="form-control" id="CurrentActorContactInfoRequest.AddressLine1"
                       [(ngModel)]="CurrentActorContactInfoRequest.AddressLine1"
                       name="CurrentActorContactInfoRequest.AddressLine1"
                       placeholder="AddressLine1"  maxlength="100"/>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12 mb-2">
                <!--<label for="eventInput2">Address Line2</label>-->
                <input type="text" class="form-control" id="CurrentActorContactInfoRequest.AddressLine2"
                       [(ngModel)]="CurrentActorContactInfoRequest.AddressLine2"
                       name="CurrentActorContactInfoRequest.AddressLine2"
                       placeholder="AddressLine2" maxlength="100"/>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12 mb-2">
                <label for="eventInput2">City</label>
                <input type="text" class="form-control" id="CurrentActorContactInfoRequest.City"
                       [(ngModel)]="CurrentActorContactInfoRequest.City"
                       name="CurrentActorContactInfoRequest.City"
                       placeholder="City" maxlength="50"/>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12 mb-2">
                <label for="eventInput2">State</label>
                <input type="text" class="form-control" id="CurrentActorContactInfoRequest.State"
                       [(ngModel)]="CurrentActorContactInfoRequest.State"
                       name="CurrentActorContactInfoRequest.State"
                       placeholder="State" maxlength="50"/>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12 mb-2">
                <label for="eventInput2">Country</label>

                <CodeTypeValue CodeType="CNTR" id="CurrentActorContactInfoRequest.Country"
                               [(ngModel)]="CurrentActorContactInfoRequest.Country" SelectedValue="{{CurrentActorContactInfoRequest.Country}}"
                               name="CurrentActorContactInfoRequest.Country"></CodeTypeValue>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12 mb-2">
                <label for="eventInput2">Cell Phone</label>
                <input type="tel" class="form-control" id="CurrentActorContactInfoRequest.Telephone1"
                       [(ngModel)]="CurrentActorContactInfoRequest.Telephone1"
                       name="CurrentActorContactInfoRequest.Telephone1"
                       placeholder="Telephone1" maxlength="20"/>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12 mb-2">
                <label for="eventInput2">Telephone</label>
                <input type="tel" class="form-control" id="CurrentActorContactInfoRequest.Telephone2"
                       [(ngModel)]="CurrentActorContactInfoRequest.Telephone2"
                       name="CurrentActorContactInfoRequest.Telephone2"
                       placeholder="Telephone2" maxlength="20"/>
              </div>
            </div>


            <div class="row">
              <div class="form-group col-12 mb-2">
                <label for="eventInput2">Email</label>
                <input type="email" class="form-control" id="CurrentActorContactInfoRequest.Email"
                       [(ngModel)]="CurrentActorContactInfoRequest.Email"
                       name="CurrentActorContactInfoRequest.Email"
                       placeholder="Email"  maxlength="30" />
              </div>
            </div>
            <!--<div class="row">
      <div class="form-group col-12 mb-2">
        <label for="eventInput2">Website</label>
        <input type="text" class="form-control" id="CurrentActorContactInfoRequest.Website"
               [(ngModel)]="CurrentActorContactInfoRequest.Website"
               name="CurrentActorContactInfoRequest.Website"
               placeholder="Website" />
      </div>
    </div>-->

            <div class="row">
              <div class="form-group col-12 mb-2">
                <label for="eventInput2">Emergency Contact</label>
                <input type="text" class="form-control" id="CurrentActorContactInfoRequest.EmergencyContactPersonName"
                       [(ngModel)]="CurrentActorContactInfoRequest.EmergencyContactPersonName"
                       name="CurrentActorContactInfoRequest.EmergencyContactPersonName"
                       placeholder="EmergencyContactPersonName" maxlength="50"/>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-12 mb-2">
                <label for="eventInput2">Emergency ContactNo</label>
                <input type="text" class="form-control" id="CurrentActorContactInfoRequest.EmergencyContactNo1"
                       [(ngModel)]="CurrentActorContactInfoRequest.EmergencyContactNo1"
                       name="CurrentActorContactInfoRequest.EmergencyContactNo1"
                       placeholder="EmergencyContactNo1" maxlength="20" />
              </div>
            </div>
            <!--<div class="row">
      <div class="form-group col-12 mb-2">
        <label for="eventInput2">Emergency Contact #2</label>
        <input type="text" class="form-control" id="CurrentActorContactInfoRequest.EmergencyContactNo2"
               [(ngModel)]="CurrentActorContactInfoRequest.EmergencyContactNo2"
               name="CurrentActorContactInfoRequest.EmergencyContactNo2"
               placeholder="EmergencyContactNo2" />
      </div>
    </div>-->
            <div class="row">
              <div class="form-group col-12 mb-2">
                <label for="eventInput2">Emergency Address</label>
                <input type="text" class="form-control" id="CurrentActorContactInfoRequest.EmergencyAddress"
                       [(ngModel)]="CurrentActorContactInfoRequest.EmergencyAddress"
                       name="CurrentActorContactInfoRequest.EmergencyAddress"
                       placeholder="EmergencyAddress" maxlength="100"/>
              </div>
            </div>




            <!--<div class="form-group">
              <div class="col-md-12">
                <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn btn-pink btn-block btn-raised">Submit</button>

              </div>
            </div>-->


          </div>
          <div class="modal-footer">
            <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn btn-primary">Submit</button>

          </div>

        </form>
                
        <!-- // Form actions layout section end -->
      </div>


      <!--<div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-raised" (click)="activeModal.close('Close click')">Close</button>
      </div>-->
    </div>
    </div>
</div>
